import { NavLink } from 'react-router-dom';
import {
  combineCls,
  display,
  flexDirection,
  fontSize,
  fontWeight,
  padding,
  textColor,
  twCls,
} from 'style';

export const navPages = [
  {
    key: 'Developments',
    path: '/developments',
    pageDisplayName: 'Developments',
    isRoot: true,
  },
  {
    key: 'Downloads',
    path: '/downloads',
    pageDisplayName: 'Downloads',
    isRoot: true,
  },
];

const navRootLinkClassName = twCls(padding('pt-3'));
const activeRootLinkClassName = combineCls(navRootLinkClassName, twCls(fontWeight('font-black')));
const setActiveRootLinkClassName = ({ isActive }: { isActive: boolean }) =>
  isActive ? activeRootLinkClassName : navRootLinkClassName;

const navChildLinkClassName = twCls(padding('pl-3'));
const activeChildLinkClassName = combineCls(navChildLinkClassName, twCls(fontWeight('font-black')));
const setActiveChildLinkClassName = ({ isActive }: { isActive: boolean }) =>
  isActive ? activeChildLinkClassName : navChildLinkClassName;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SidebarProps {}

export const Sidebar = (): JSX.Element => {
  return (
    <div className={twCls(display('flex'), flexDirection('flex-col'), padding('px-4'))}>
      <div
        className={twCls(padding('pt-11', 'pb-6'), fontSize('text-3xl'), fontWeight('font-light'))}
      >
        Admin Portal
      </div>
      <nav
        className={twCls(
          display('flex'),
          flexDirection('flex-col'),
          textColor('text-blue-100'),
          fontSize('text-lg'),
          fontWeight('font-medium'),
        )}
      >
        {navPages.map(({ key, path, pageDisplayName, isRoot }) => (
          <NavLink
            key={key}
            to={path}
            className={isRoot ? setActiveRootLinkClassName : setActiveChildLinkClassName}
            end={true}
          >
            {pageDisplayName}
          </NavLink>
        ))}
      </nav>
    </div>
  );
};
